/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'search': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M35.602 32.755l-5.878-5.879a9.433 9.433 0 0 0 1.521-5.132c0-5.235-4.262-9.494-9.496-9.494-5.236 0-9.494 4.259-9.494 9.494 0 5.236 4.258 9.495 9.494 9.495a9.43 9.43 0 0 0 5.132-1.519l5.878 5.878a.505.505 0 0 0 .712 0l2.132-2.132a.502.502 0 0 0-.001-.711zM15.269 21.744a6.487 6.487 0 0 1 6.479-6.479 6.486 6.486 0 0 1 6.479 6.479 6.485 6.485 0 0 1-6.479 6.479 6.486 6.486 0 0 1-6.479-6.479z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/search.js